"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostSalesmanEdit = void 0;
const Base_1 = require("./Base");
exports.PostSalesmanEdit = {
    url: Base_1.URL_BASE + "/SalesmanEdit",
    method: "POST",
    secure: true
};
//# sourceMappingURL=PostSalesmanEdit.js.map